import '.ce{position:relative;}.ssr-plugin'
import '.ek{appearance:none;}.ssr-plugin'
import '.br{flex-shrink:0;}.ssr-plugin'
import '.cs{width:1.5rem;}.ssr-plugin'
import '.ct{height:1.5rem;}.ssr-plugin'
import '.ii{border-radius:2.125rem;}.ssr-plugin'
import '.gn{border:2px solid var(--gray-200);}.ssr-plugin'
import '.ch{background:var(--shades-white);}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.f{align-items:center;}.ssr-plugin'
import '.as{font-style:normal;}.ssr-plugin'
import '.ar{font-weight:400;}.ssr-plugin'
import '.ca{user-select:none;}.ssr-plugin'
import '.be{gap:0.5rem;}.ssr-plugin'
import { styled } from 'inlines'
import { useId } from 'react'
import { Icon } from '../icon/Icon'
import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons'
import { Tooltip } from '../tooltip/Tooltip'

export type RadioButtonProps = {
  selected: boolean
  groupName?: string
  label?: string
  labelPosition?: 'right' | 'left'
  labelSize?: 'medium' | 'small'
  disabled?: boolean
  style?: React.CSSProperties
  onClick: () => void
  tooltipText?: string
}

export const RadioButton = ({
  selected,
  groupName,
  label,
  labelPosition = 'right',
  labelSize = 'medium',
  disabled = false,
  style,
  tooltipText,
  onClick,
}: RadioButtonProps) => {
  const id = useId()
  const handler = () => {
    if (!disabled) {
      onClick()
    }
  }

  const input = (
    <styled.input className="ce ek br cs ct ii gn ch"
      key="input-label"
      id={id}
      name={groupName || ''}
      checked={selected}
      type="radio"
      disabled={disabled}
      onChange={handler}
      style={{
        cursor: disabled ? 'not-allowed' : 'pointer',
        '&:hover': {
          border: '2px solid var(--gray-300)',
        },
        '&:checked': {
          background: 'radial-gradient(circle at center, white 0.25rem, var(--primary-red) 0.25rem)',
          border: '2px solid var(--primary-red)',
          animation: 'radio-button-checked 0.2s ease-out',
        },
        '&:disabled': {
          background: 'var(--gray-100)',
          border: '2px solid var(--gray-200)',
        },
        '&:checked:disabled': {
          background: 'radial-gradient(circle at center, white 0.25rem, var(--shades-blue-100) 0.25rem)',
          border: '2px solid var(--shades-blue-100)',
          animation: 'radio-button-checked 0.2s ease-out',
        },

      }}
    />
  )

  const labelComponent = <styled.div key="radio-label">{label}</styled.div>
  const components = !label
    ? input
    : labelPosition === 'right'
      ? [input, labelComponent]
      : [labelComponent, input]

  return (
    <styled.label className="a f as ar ca"
      htmlFor={id}
      style={{
        fontSize: labelSize === 'medium' ? '1.5rem' : '1.125rem',
        cursor: disabled ? 'not-allowed' : 'pointer',
        ...style,
      }}
    >
      <div className="a f be">
        {components}
      </div>
      {tooltipText && (
        <styled.span
        onClick={(e: React.MouseEvent) => {
          e.preventDefault()
          e.stopPropagation()
        }}>
          <Tooltip content={tooltipText}>
            <Icon 
              icon={faCircleInfo} 
              style={{ 
                color: 'var(--shades-blue-200)',
                '&:hover': { color: 'var(--primary-blue)' },
                '&:focus-visible': { color: 'var(--primary-blue)' }, 
              }} 
              size="small"
            />
          </Tooltip>
        </styled.span>
      )}
    </styled.label>
  )
}
